import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class BitacoraService {
  async getBitacorasAll(){
    return await fetchWrapper.get(`${ruta}/bitacoras`);
  }
}